/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Box } from '@mui/material';
import BaseShimmer from './BaseShimmer';
import './shimmer.scss';

function CardShimmer({
  showImage = true,
  showButton = true,
  textLines = 3,
  className = '',
  style = {},
}) {
  return (
    <Box className={`shimmer-card ${className}`} sx={style}>
      {showImage && (
        <BaseShimmer
          className="shimmer-card-image"
          height="200px"
          borderRadius="8px"
        />
      )}

      <BaseShimmer
        className="shimmer-card-title"
        height="24px"
        width="80%"
      />

      <BaseShimmer
        className="shimmer-card-subtitle"
        height="16px"
        width="60%"
      />

      {Array.from({ length: textLines }).map((_, index) => (
        <BaseShimmer
          key={index}
          className="shimmer-card-text"
          height="14px"
          width={index === textLines - 1 ? '75%' : index === 0 ? '100%' : '90%'}
        />
      ))}

      {showButton && (
        <BaseShimmer
          className="shimmer-card-button"
          height="36px"
          width="120px"
          borderRadius="6px"
        />
      )}
    </Box>
  );
}

export default CardShimmer;
